import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AcademyLogin from './pages/AcademyLogin';
import Dashboard from './pages/Dashboard';
import AthleteCheckIn from './pages/AthleteCheckIn';
import AthleteList from './pages/AthleteList';
import AthleteProfile from './pages/AthleteProfile';
import ParentView from './pages/ParentView';
import SportDashboard from './pages/SportDashboard';
import AthleteDashboard from './pages/AthleteDashboard';
import SessionPlannerPage from './pages/SessionPlannerPage';
import MeditationPage from './pages/MeditationPage';
import AcademyProfile from './pages/AcademyProfile';
import VitalsScan from './pages/VitalsScan';
import GymTrainerDashboard from './pages/GymTrainerDashboard';
import GymMemberDashboard from './pages/GymMemberDashboard';
import GymTrainingLog from './pages/GymTrainingLog';
import MessagesInbox from './pages/MessagesInbox';
import UpgradeGate from './components/common/UpgradeGate';
import Terms from './pages/legal/Terms';
import Privacy from './pages/legal/Privacy';
import Refund from './pages/legal/Refund';
import Contact from './pages/legal/Contact';


const ProtectedRoute = ({ children, allowedRole }) => {
  const role = localStorage.getItem('role');
  const academyId = localStorage.getItem('academyId');

  if (!academyId) return <Navigate to="/" />;
  if (!role) return <Navigate to="/login" />;
  if (allowedRole && role !== allowedRole) return <Navigate to="/login" />;
  return children;
};

const AcademyRoute = ({ children }) => {
  const academyId = localStorage.getItem('academyId');
  if (!academyId) return <Navigate to="/" />;
  return children;
};

function App() {
  return (
    <Router>
      <UpgradeGate />
      <Routes>
        <Route path="/" element={<AcademyLogin />} />

        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/login" element={
          <AcademyRoute><Login /></AcademyRoute>
        } />

        <Route path="/dashboard" element={
          <ProtectedRoute allowedRole="coach"><Dashboard /></ProtectedRoute>
        } />
        <Route path="/gym-dashboard" element={
          <ProtectedRoute allowedRole="coach"><GymTrainerDashboard /></ProtectedRoute>
        } />
        <Route path="/gym-member-dashboard" element={
          <ProtectedRoute allowedRole="athlete"><GymMemberDashboard /></ProtectedRoute>
        } />
        <Route path="/gym-training-log" element={
          <ProtectedRoute allowedRole="coach"><GymTrainingLog /></ProtectedRoute>
        } />
        <Route path="/athletes" element={
          <ProtectedRoute allowedRole="coach"><AthleteList /></ProtectedRoute>
        } />
        <Route path="/athlete/:name" element={
          <ProtectedRoute allowedRole="coach"><AthleteProfile /></ProtectedRoute>
        } />
        <Route path="/sport/:sport" element={
          <ProtectedRoute allowedRole="coach"><SportDashboard /></ProtectedRoute>
        } />
        <Route path="/session-planner" element={
          <ProtectedRoute allowedRole="coach"><SessionPlannerPage /></ProtectedRoute>
        } />
        <Route path="/messages" element={
          <ProtectedRoute allowedRole="coach"><MessagesInbox /></ProtectedRoute>
        } />

        <Route path="/vitals" element={
          <ProtectedRoute allowedRole="athlete"><VitalsScan /></ProtectedRoute>
        } />
        <Route path="/checkin" element={
          <ProtectedRoute allowedRole="athlete"><AthleteCheckIn /></ProtectedRoute>
        } />
        <Route path="/athlete-dashboard" element={
          <ProtectedRoute allowedRole="athlete"><AthleteDashboard /></ProtectedRoute>
        } />

        <Route path="/parent" element={
          <AcademyRoute><ParentView /></AcademyRoute>
        } />

        <Route path="/meditation" element={
          <AcademyRoute><MeditationPage /></AcademyRoute>
        } />
        <Route path="/academy-profile" element={
          <AcademyRoute><AcademyProfile /></AcademyRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;